import MyProfileComponent from "../../component/my-profile";

const Profile = () => {
  return <MyProfileComponent shouldShowChangePassword={true} />;
};

export default Profile;
